interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionTitle({
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
}: SectionTitleProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "flex flex-col items-center text-center" : ""}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.3em] uppercase mb-3 ${
            light ? "text-accent-300" : "text-primary-600"
          }`}
        >
          <span className={`block w-6 h-px ${light ? "bg-accent-400" : "bg-primary-400"}`}></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold leading-snug ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-3 md:mt-4 text-sm md:text-base leading-relaxed max-w-3xl ${
            light ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}